<router-outlet></router-outlet>
@if (!chatStore.availability.disabled()) {
  <app-joii-chat />
}
